
/*
Author: Vinod
Date: 24/01//2020
Issue Description: Monthly TDS Report.
search_string: PL_2410
*/

/*
Author: Vinod
Date: 08/04/2020
Issue Description: month value change in request body.
search_string: PL_3048
*/

/*
Author: Vinod
Date: 16/04/2020
Issue Description: Change in implementation to download reports for more than 100 employees.
search_string: PL_3064
*/

<template>
  <div class="main-container">
    <breadcrumb :list="breadcrumbList" />
    <tl-header type="h3" class="head">Company Reports</tl-header>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <!-- <div class="link" v-on:click="customreport">Create Custom Report</div> -->
    <div class="type">
      <tl-select
        label="Report Type"
        :options="['Bank','Payroll','Statutory']"
        @change="(val)=>rpttypechanged(val)"
      />
      <tl-select
        v-if="this.reptype"
        label="Sub-Report Type"
        :options="subreptypeoption"
        v-model="subreptype"
        @change="(val)=>subreptype=val"
      />
    </div>
    <div v-if="this.subreptype && this.subreptype != '24Q Report'">
      <div class="header header3 subtype">
        <span class="text">{{this.subreptype}}</span>
      </div>
      <div class="type">
        <tl-select
          label="Financial Year"
          labelText="name"
          :options="financialYearList"
          v-model="financialYear"
          @change="(val)=>{financialYear=val; getFinancialYearMonths();}"
        />
        <tl-select
          label="Month"
          labelText="name"
          :options="monthOptions"
          @change="(val)=>month=val"
        />
      </div>
      <div v-if="this.subreptype && this.subreptype != 'Head Count Reports'">
        <div class="row margin-t-m">
          <div class="col-3 padding-l-n">
            <tl-select
              label="Paygroup"
              labelText="name"
              v-model="paygroup"
              :multiple="true"
              :options="paygroupOptions"
              @change="(val)=>paygroup = val"
            />
          </div>
          <div class="col-3">
            <tl-select
              label="Criteria"
              v-model="criteria"
              :options="criteriaOptions"
              @change="(val) => {criteria = val;onSelectCriteria(val)}"
            />
          </div>
          <div class="col-3" v-if="subCriteriaLabel">
            <tl-select
              :label="subCriteriaLabel"
              labelText="name"
              v-model="subcriteria"
              :multiple="true"
              :options="subCriteriaList"
              @change="(val)=>subcriteria = val"
            />
          </div>
          <div class="col-3" v-if="subCriteriaLabel">
            <btn text="Apply Filters" type="secondary" class="btn-filter" @click="applyFilter"></btn>
          </div>
        </div>
        <div class="header header2">
          <div class="line"></div>
        </div>
        <div class="employeecard d-pending">
          <!-- @click="gotoEmployees" -->
          <span class="emptext">{{empcount}}</span>
          <span class="empselect">Employees Selected</span>
        </div>
      </div>

      <bottom-action-container>
        <template slot="end">
          <btn-grp>
            <btn text="Download" type="primary" @click="downloadReport()" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </div>

    <div v-if="this.subreptype && this.subreptype == '24Q Report'">
      <div class="header header3 subtype">
        <span class="text">{{this.subreptype}}</span>
      </div>
      <twenty-four-q-report></twenty-four-q-report>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import twentyFourQReport from "./twentyFourQReport.vue";
import { debug } from "util";
import { monthOptionsObj, criteriaObj } from "../../../../../apis/constants.js";
export default {
  data() {
    return {
      breadcrumbList: [
        {
          name: "Reports",
          url: `/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard`
        },
        {
          name: "Company Reports",
          url: `/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/companyReports`
        }
      ],
      reptype: "",
      subreptype: "",
      financialYear: "",
      month: "",
      customEmpList: [],
      employeeData: [],
      toast: false,
      errmsg: "",
      empcount: 0,
      monthOptions: [],
      monthsList: monthOptionsObj.monthListForFinancialYear,
      financialYearList: [],
      criteriaOptions: criteriaObj.reportCriteria,
      monthArray: monthOptionsObj.onlyMonths,
      subCriteriaLabel: "",
      subCriteriaList: [],
      paygroupOptions: [],
      paygroup: [],
      criteria: null,
      subcriteria: [],
      dropdownList: [],
      statusLabel: "",
      statusOptions: "",
      request: {}
    };
  },
  watch: {
    subreptype(val) {
      try {
        this.employeeData = [];
        switch (this.subreptype) {
          case "Claims": {
            this.statusLabel = "Claims Status";
            this.statusOptions = ["Approved", "Partially Approved", "Rejected"];
            break;
          }
          case "Declaration Report": {
            this.statusLabel = "Declaration Status";
            this.statusOptions = ["Declared", "Not Declared"];
            break;
          }
          case "Investment Proof": {
            this.statusLabel = "Investment Proof Status";
            this.statusOptions = ["Submitted", "Approved", "Disapproved"];
            break;
          }
          case "FBP Payout": {
            this.statusLabel = "FBP Payout Status";
            this.statusOptions = ["Monthly", "For Employee", "Overall"];
            break;
          }
          case "Statutory bonus": {
            this.statusLabel = "Statutory bonus Status";
            this.statusOptions = ["Monthly", "Yearly"];
            break;
          }
          default:
            this.statusLabel = "";
            this.statusOptions = [];
            break;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  },
  computed: {
    subreptypeoption() {
      if (this.reptype == "Bank")
        return [
          "Bank Advice",
          "Bank Transfer",
          "Bank Summary",
          "Payroll Summary"
        ];
      if (this.reptype == "Payroll")
        return [
          "Salary Register",
          "Journal Voucher",
          "Variance"
        ];
      if (this.reptype == "Statutory")
        return [
          "PF",
          "ESI",
          "LWF",
          "PT",
          "IT"
        ];
      return [];
    },
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    }
  },
  components: {
    twentyFourQReport
  },
  activated() {
    this.count();
    this.getPaygroups();
    this.generateFinancialYear();
  },
  methods: {
    ...mapActions({
      downloadSR:
        "dashboard/payroll/reports/Reports/downloadSalaryRegisterReport",
      downloadCTC: "dashboard/payroll/reports/Reports/downloadSalaryCTCReport",
      downloadVariance:
        "dashboard/payroll/reports/Reports/downloadVarianceReport",
      downloadJV: "dashboard/payroll/reports/Reports/downloadJVReport",
      downloadHC: "dashboard/payroll/reports/Reports/downloadHCReport",
      downloadBA: "dashboard/payroll/reports/Reports/downloadBAReport",
      downloadBT: "dashboard/payroll/reports/Reports/downloadBTReport",
      downloadTDS: "dashboard/payroll/reports/Reports/downloadTDSReport", // PL_2410
      downloadLOP: "dashboard/payroll/reports/Reports/downloadLOPReport",
      downloadStatutory:
        "dashboard/payroll/reports/Reports/downloadStatutoryReports",
      fetchEmployees: "globalapi/globalemployees/fetchAll",
      fetchEmployeeByName: "globalapi/globalemployees/fetchByName",
      act_fetch: "dashboard/payroll/reports/Reports/fetchAll",
      fetch_paygroups: "onboard/paygroup/fetchAll",
      fetch_locations: "onboard/locations/fetchAll",
      fetch_grades: "onboard/salary_grades/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_departments: "onboard/departments/fetchAll",
      fetch_cost_center: "onboard/cost_centres/fetchAll",
      fetch_designation: "onboard/designations/fetchAll"
    }),


   /* function to count the employees based on the length of list */
    count() {
      try {
        if (this.$route.params.selemplist) {
          this.empcount = this.$route.params.selemplist.length;
        } else {
          this.empcount = this.employeeData.length;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to generate financial year from previous 5 years */
    generateFinancialYear() {
      try {
        let date = new Date();
        let year =
          date.getMonth() > 2 ? date.getFullYear() : date.getFullYear() - 1;
        for (let i = year; i > year - 5; i--) {
          this.financialYearList.push({
            name: i + "-" + (i + 1),
            value: i + ""
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to get months of a financial year based on selected financial year */
    getFinancialYearMonths() {
      try {
        let date = new Date();
        if (
          date.getMonth() > 2 &&
          this.financialYear.value == date.getFullYear()
        ) {
          let index = this.monthsList.findIndex(
            item => item.name == this.monthArray[date.getMonth()]
          );
          this.monthOptions = this.monthsList.slice(0, index + 1);
        } else if (this.financialYear.value < date.getFullYear() - 1) {
          this.monthOptions = this.monthsList;
        } else if (this.financialYear.value == date.getFullYear() - 1) {
          if (date.getMonth() < 3) {
            let index = this.monthsList.findIndex(
              item => item.name == this.monthArray[date.getMonth()]
            );
            this.monthOptions = this.monthsList.slice(0, index + 1);
          } else {
            this.monthOptions = this.monthsList;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get employees based on selected filter optons */
    async applyFilter() {
      try {
        let obj = {
          le_id: this.le_id,
          month: this.month.value,
          financial_year: this.financialYear.value,
          bands:
            this.criteria == "Band"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          bunits:
            this.criteria == "Business Unit"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          cost_centers:
            this.criteria == "Cost Centre"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          locs:
            this.criteria == "Location"
              ? this.subcriteria.map(item => {
                  return item.id;
                })
              : [],
          paygroups: this.paygroup.length
            ? this.paygroup.map(item => {
                return item.id;
              })
            : []
        };
        let res = await this.act_fetch({ obj: obj, page: 1 });
        if (res.data.status) {
          this.employeeData = res.data.payload.data;
          this.empcount = res.data.payload.totalEmpCount;
               // PL_3064
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to get subcriteria after selecting criteria */
    onSelectCriteria(event) {
      try {
        this.subcriteria = [];
        if (event == "Location") {
          this.subCriteriaLabel = "Location";
          this.getLocations();
        } else if (event == "Cost Centre") {
          this.subCriteriaLabel = "Cost Centre";
          this.getCostCenter();
        } else if (event == "Band") {
          this.subCriteriaLabel = "Band";
          this.getBands();
        } else if (event == "Grade") {
          this.subCriteriaLabel = "Grade";
          this.getGrades();
        } else if (event == "Department") {
          this.subCriteriaLabel = "Department";
          this.getDepartments();
        } else {
          this.subCriteriaLabel = "Sub Criteria";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get locations for the current legal entity */
    async getLocations() {
      try {
        let res = await this.fetch_locations(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get salary bands for the current legal entity */
    async getBands() {
      try {
        let res = await this.fetch_bands(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get paygroups for the current legal entity */
    async getPaygroups() {
      try {
        let res = await this.fetch_paygroups(this.le_id);
        if (res.data.status) {
          this.paygroupOptions = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get business units for the current organisation */
    async getDepartments() {
      try {
        let res = await this.fetch_departments(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get cost centres for the current legal entity */
    async getCostCenter() {
      try {
        let res = await this.fetch_cost_center(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get salary grades for the current legal entity */
    async getGrades() {
      try {
        let res = await this.fetch_grades(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to download reports of various types */
    async downloadReport() {
      try {
        let obj = {
                le_id: this.le_id,
                month: this.month.value,
                financialYear: this.financialYear.value,
                bands:
                  this.criteria == "Band"
                    ? this.subcriteria.map(item => {
                        return item.id;
                      })
                    : [],
                bunits:
                  this.criteria == "Business Unit"
                    ? this.subcriteria.map(item => {
                        return item.id;
                      })
                    : [],
                cost_centers:
                  this.criteria == "Cost Centre"
                    ? this.subcriteria.map(item => {
                        return item.id;
                      })
                    : [],
                locs:
                  this.criteria == "Location"
                    ? this.subcriteria.map(item => {
                        return item.id;
                      })
                    : [],
                paygroups: this.paygroup.length
                  ? this.paygroup.map(item => {
                      return item.id;
                    })
                  : []
              };
        if (this.subreptype == "Salary Report") {
          // if (
          //   this.$route.params.selemplist &&
          //   this.$route.params.selemplist.length
          // ) {
          //   this.employeeData = this.$route.params.selemplist;
          // }
          if (this.financialYear.value && this.month) {
            /* PL_3064 */
            let res = await this.downloadSR({
              data: obj
            });
            this.toast = false;
          } else {
            this.toast = true;
            this.errmsg = "Please select financial year and month";
          }
        }
        if (this.subreptype == "CTC Reconciliation") {
          // let selectedEMployeesList = [];
          // if (this.$route.params.selemplist) {
          //   selectedEMployeesList = this.$route.params.selemplist;
          // } else {
          //   selectedEMployeesList = this.employeeData;
          // }

          let res = await this.downloadCTC({
            data: obj
          });
        }
        if (this.subreptype == "LOP Report") {
          this.downloadlop(obj);
        }
        if (this.subreptype == "JV Reports") {
          this.downloadJVReports(obj);
        }
        if (this.subreptype == "Variance Reports") {
          this.downloadVarianceReports(obj);
        }
        if (this.subreptype == "Head Count Reports") {
          this.downloadHCReports(obj);
        }
        if (this.subreptype == "Salary Bank Advise Reports") {
          this.downloadBAReports(obj);
        }
        if (this.subreptype == "Bank Advise Transfer Reports") {
          this.downloadBTReports(obj);
        }
        // PL_2410
        if (this.subreptype == "TDS Report") {
          this.downloadTDSReports(obj);
        }
        if (this.subreptype == "PF") {
          this.downloadStatutoryReports(obj, "pf_report");
        }
        if (this.subreptype == "ESI") {
          this.downloadStatutoryReports(obj, "esi_report");
        }
        if (this.subreptype == "LWF") {
          this.downloadStatutoryReports(obj, "lwf_report");
        }
        if (this.subreptype == "PT") {
          this.downloadStatutoryReports(obj, "pt_report");
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to download JV reports */
    async downloadJVReports(obj) {
      try {
        // if (
        //   this.$route.params.selemplist &&
        //   this.$route.params.selemplist.length
        // ) {
        //   this.employeeData = this.$route.params.selemplist;
        // }
        if (this.financialYear.value && this.month) {
          this.toast = false;
          let res = await this.downloadJV({
            data: obj
          });
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to download Variance reports */
    async downloadVarianceReports(obj) {
      try {
        // if (
        //   this.$route.params.selemplist &&
        //   this.$route.params.selemplist.length
        // ) {
        //   this.employeeData = this.$route.params.selemplist;
        // }
        if (this.financialYear.value && this.month) {
          let previousMonth = "";
          let previousYear = "";
          if (this.month.name == "January") {
            previousMonth = "December";
            previousYear = Number(this.financialYear.value) - 1 + "";
          } else {
            previousYear = this.financialYear.value;
            previousMonth = this.monthsList[
              this.monthsList.findIndex(item => item.name == this.month.name) -
                1
            ];
          }
          let res = await this.downloadVariance({
            data: {
              ...obj,
              preFinancialYear: previousYear,
              preMonth: previousMonth

            }
          });
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to download HeadCount reports */
    async downloadHCReports(obj) {
      try {
        if (this.financialYear.value && this.month) {
          let res = await this.downloadHC({
            data: obj
          });
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to download TDS reports */
    //  Start PL_2410
    async downloadTDSReports(obj) {
      try {
        // if (
        //   this.$route.params.selemplist &&
        //   this.$route.params.selemplist.length
        // ) {
        //   this.employeeData = this.$route.params.selemplist;
        // }
        if (this.financialYear.value && this.month) {
          let res = await this.downloadTDS({
            data: obj
          });
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to download Salary Bank Advise reports */
    //  End PL_2410
    async downloadBAReports(obj) {
      try {
        // if (
        //   this.$route.params.selemplist &&
        //   this.$route.params.selemplist.length
        // ) {
        //   this.employeeData = this.$route.params.selemplist;
        // }
        if (this.financialYear.value && this.month) {
          let res = await this.downloadBA({
            data: obj
          });
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to download Statutory reports */
    async downloadStatutoryReports(obj, reportType) {
      try {
        // if (
        //   this.$route.params.selemplist &&
        //   this.$route.params.selemplist.length
        // ) {
        //   this.employeeData = this.$route.params.selemplist;
        // }
        if (this.financialYear.value && this.month) {
          let res = await this.downloadStatutory({
            data: {
              ...obj,
              report: reportType,
            }
          });
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to download Bank Advise Transfer reports */
    async downloadBTReports(obj) {
      try {
        // if (
        //   this.$route.params.selemplist &&
        //   this.$route.params.selemplist.length
        // ) {
        //   this.employeeData = this.$route.params.selemplist;
        // }
        if (this.financialYear.value && this.month) {
          let res = await this.downloadBT({
            data: obj
          });
          this.toast = false;
        } else {
          this.toast = true;
          this.errmsg = "Please select financial year and month";
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to download LOP reports */
    async downloadlop(obj) {
      // try {
      //   if (this.$route.params.selemplist) {
      //     this.preparereq(this.$route.params.selemplist);
      //   } else {
      //     this.preparereq(this.employeeData);
      //   }
      // } catch (error) {
      //   this.toast = true;
      //   this.errmsg = error;
      // }
      try {
        let res = await this.downloadLOP({ data: obj });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async preparereq(emplist) {
      try {
        let employees = [];
        emplist.forEach(emp => {
          let obj = {};
          obj.emp_id = emp.id;
          obj.emp_name = emp.first_name;
          obj.emp_code = emp.code;
          obj.le_id = emp.legal_entity_id;
          employees.push(obj);
        });
        this.request = {
          employees: employees,
          month: this.month.name,
          financial_year: this.financialYear.value
        };
        // call store action
        let res = await this.downloadLOP({ data: this.request });
      } catch (err) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to go to create custom reports */
    customreport() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/reportModule/custom`
      });
    },

    /* function to go to employees list to select */
    // currently not being used
    gotoEmployees() {
      try {
        if (this.subreptype != "Salary Report") {
          let selectedEMployeesList = [];
          if (this.$route.params.selemplist) {
            selectedEMployeesList = this.$route.params.selemplist;
          } else {
            selectedEMployeesList = this.employeeData;
          }
          this.$router.push({
            name: "dashboardSubstepname",
            params: {
              step_name: this.$route.params.step_name,
              sub_step: this.$route.params.sub_step,
              sub_step_name: "employees",
              entity_index: this.$route.params.entity_index,
              selectedEmpList: selectedEMployeesList,
              emplList: this.employeeData
            }
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to reset other fields after changing report type*/
    rpttypechanged(val) {
      try {
        this.reptype = val;
        this.subreptype = "";
        this.subCriteriaList = [];
        (this.subcriteria = []), (this.criteria = "");
        this.paygroup = [];
        this.subCriteriaLabel = "";
        this.month = "";
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.head {
  margin-top: 37px;
}

.type {
  display: flex;
  margin-top: 30px;
  div {
    width: 250px;
    padding-right: 20px;
  }
}

.subtype {
  margin-top: 25px;
}

.link {
  color: #5d409f;
  font-size: 12px;
  text-decoration: underline;
  padding-top: 10px;
  cursor: pointer;
}

.employeecard {
  margin-bottom: 20px;
  position: relative;
  border: solid 1px #f0f0f0;
  border-left: solid 10px;
  height: 65px;
  width: 205px;
  border-radius: 4px;
  padding-left: 13px;
  display: grid;
  align-items: center;
  font-size: 12px;
  background: #fbfbfb;
}

.d-pending {
  color: #34c0be;
  display: flex;
  margin-top: 30px;
  cursor: pointer;
}

.emptext {
  font-size: 40px;
  font-weight: 600;
  color: #34c0be;
  padding-right: 10px;
}

.empselect {
  color: #646464;
  width: 82px;
  font-weight: 500;
  font-size: 14px;
}

.header.header3 {
  padding-bottom: 0px;
}
</style>
